import PropTypes from 'prop-types';

export { default } from './FlexContainer';

export const sharedProps = {
  style: PropTypes.object,
  children: PropTypes.node,
  justifyContent: PropTypes.oneOf(['center', 'space-between', 'space-around', 'flex-start', 'flex-end']),
};
